import { useLocation } from "react-router-dom";
import { Plus } from "lucide-react";

const titleMap = {
  "/dashboard": { title: "Dashboard", sub: "Retainer health this month." },
  "/retainers": { title: "Retainers", sub: "All your retainer clients." },
  "/snapshots": { title: "Snapshots", sub: "Save each month, compare over time." },
  "/pricing": { title: "Pricing", sub: "Plans by number of retainers." },
  "/settings": { title: "Settings", sub: "Defaults for new clients." },
};

const Header = ({ onAddClient }) => {
  const location = useLocation();
  const base = "/" + location.pathname.split("/")[1];
  const meta = titleMap[base] || { title: "Dashboard", sub: "" };

  const showAddBtn = base === "/dashboard" || base === "/retainers";

  return (
    <header
      className="sticky top-0 z-30 backdrop-blur-md bg-[#F8F6F1]/80 border-b border-[#E4DFD2] px-8 py-4 flex justify-between items-center"
      data-testid="app-header"
    >
      <div>
        <div className="text-[11px] tracking-[0.1em] uppercase font-semibold text-[#B89B5E]">
          RetainerTracker
        </div>
        <h1 className="font-display text-xl tracking-tight font-semibold text-[#1F2326]">
          {meta.title}
        </h1>
      </div>
      {showAddBtn && (
        <button
          type="button"
          onClick={onAddClient}
          data-testid="header-add-client-btn"
          className="bg-[#1F2326] text-[#F8F6F1] hover:bg-[#2A2E32] px-4 py-2 rounded-lg font-medium text-sm transition-colors inline-flex items-center gap-2 shadow-sm"
        >
          <Plus className="w-4 h-4" strokeWidth={2.5} />
          Add Retainer
        </button>
      )}
    </header>
  );
};

export default Header;
